// Contact information
export const CONTACT_EMAIL = "contact@agentmrr.com";

// Social links
export const SOCIAL_LINKS = {
	email: `mailto:${CONTACT_EMAIL}`,
} as const;

// Company info
export const COMPANY_NAME = "AgentMRR";
export const COMPANY_DOMAIN = "agentmrr.com";

// Square logo Stripe can fetch for checkout product branding.
export const CHECKOUT_BRAND_IMAGE_URL = `https://${COMPANY_DOMAIN}/app-icon.png`;
